/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type CreateIssueReportBodyDevice = (typeof CreateIssueReportBodyDevice)[keyof typeof CreateIssueReportBodyDevice];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateIssueReportBodyDevice = {
  desktop: "desktop",
  mobile: "mobile",
  tablet: "tablet",
} as const;
